'use strict';

var Backbone = require('backbone');
var Radio = require('backbone.radio');
var _ = require('underscore');

var StepView = require('./step').default;
var polyglot = require('../../utilities/polyglot').default;
var Appointment = require('../../models/appointment').default;
var LanguageCollection = require('../../collections/languages').default;

export default StepView.extend({

  onSaveSuccess: function (data, textStatus, jqXHR) {
    window.APPOINTMENTS = _.map(data.data.appointment, function(appointment) {
      return new Appointment(appointment);
    });
    this.formView.enableSubmit();
    Radio.channel('confirm').trigger('confirm:message', window.REQUEST_START
      ? polyglot.t('pages.confirmation.wait_list_title')
      : polyglot.t('pages.confirmation.long_title'));
    Backbone.history.navigate(polyglot.t('pages.confirmation.slug'), {trigger: true});
  },

  onSaveError: function (jqXHR, textStatus, errorThrown) {
    if (window.REQUEST_START && window.REQUEST) {
      /* when trying to book appointment from wait list request, redirect to
      wait list confirmation page with error message */
      const BOOK_ATTEMPT_FAILED = 2;
      const request = window.REQUEST;
      const { origin, pathname } = Backbone.history.location;
      const lang = new LanguageCollection(window.LANGUAGES).getCurrent();
      const search = `?lang=${lang}&request_id=${request.id}&cid=${request.client.id}&avail=${BOOK_ATTEMPT_FAILED}`;
      Backbone.history.location.href = `${origin}${pathname}${search}#${polyglot.t('pages.waitlist_confirmation.slug')}`;
    } else {
      this.formView.enableSubmit();
      Radio.channel('toast').trigger('show', {
        message: this.getErrorMessage(jqXHR),
        iconColor: 'error',
      });
      Radio.channel('buttons').request('book:enable');
    }
  },

  /*
   * Get error message based on response
   */
  getErrorMessage: function (response) {
    if (!_.isEmpty(response.responseJSON.type)
        && response.responseJSON.type === 'stripe') {
      return polyglot.t('forms.stripe_error.generic');
    }

    if (!_.isEmpty(response.responseJSON.data)) {
      return _.flatten(_.values(response.responseJSON.data)).join('<br>');
    }

    if (response.responseJSON.message) {
      return response.responseJSON.message;
    }

    return this.defaultErrorMessage;
  },

});
